<ng-template #ring>
  <div
    class="relative flex items-center justify-center p-1"
    [style.width.px]="chartSize()"
    [style.height.px]="chartSize()"
  >
    <div class="relative w-full h-full" [class.opacity-0]="!displayChart()" [class.opacity-100]="displayChart()">
      <div
        echarts
        class="w-full h-full"
        [options]="chartOption()"
        (chartInit)="onChartInit($event)"
        (chartFinished)="onChartFinished()"
        (chartClick)="onChartClick($event)"
      ></div>

      @if (showTotal() && displayChart()) {
        @if (totalCountCentered()) {
          <div class="absolute inset-0 flex items-center justify-center select-none pointer-events-none">
            <div class="flex flex-col items-center">
              <span [class]="totalLabelFontClass()" class="invisible" aria-hidden="true">{{
                'shared.total' | translate
              }}</span>
              <div class="h-1 invisible" aria-hidden="true"></div>
              <span [class]="totalCountFontClass()">{{ actualTotal() }}</span>
              <div class="h-1"></div>
              <span [class]="totalLabelFontClass()">{{ 'shared.total' | translate }}</span>
            </div>
          </div>
        } @else {
          <div class="absolute inset-0 flex flex-col items-center justify-center select-none pointer-events-none">
            <span [class]="totalCountFontClass()">{{ actualTotal() }}</span>
            <span [class]="totalLabelFontClass()">{{ 'shared.total' | translate }}</span>
          </div>
        }
      } @else if (showPercentage() && displayChart()) {
        <div class="absolute inset-0 flex items-center justify-center select-none pointer-events-none">
          <span
            class="font-medium text-3xl !pointer-events-auto"
            [matTooltip]="
              data().total !== null
                ? ('pages.campaignDetails.overview.currentProgress' | translate)
                : ('pages.campaignDetails.overview.noTargetSet' | translate)
            "
          >
            {{ centerPercentage() }}
          </span>
        </div>
      }
    </div>

    @if (!displayChart()) {
      <div class="absolute pt-[6px]">
        <ngx-skeleton-loader
          [style.height]="skeletonSize() + 'px'"
          [theme]="{
            height: skeletonSize() + 'px',
            width: skeletonSize() + 'px',
            'border-radius': '100vw',
          }"
        />
      </div>
    }
  </div>
</ng-template>

@if (legendEntries() !== null) {
  <div class="inline-flex items-center gap-4">
    <ng-container [ngTemplateOutlet]="ring" />

    <div class="flex flex-col gap-2">
      @if (loading()) {
        @for (slot of legendSkeletonSlots(); track slot) {
          <div class="flex items-center gap-6">
            <div class="flex w-[120px] items-center gap-2">
              <ngx-skeleton-loader [theme]="{ width: '8px', height: '8px', 'border-radius': '50%', margin: '0' }" />
              <ngx-skeleton-loader [theme]="{ width: '80px', height: '14px', 'border-radius': '4px', margin: '0' }" />
            </div>
            <ngx-skeleton-loader [theme]="{ width: '30px', height: '14px', 'border-radius': '4px', margin: '0' }" />
          </div>
        }
      } @else {
        @for (entry of legendEntries()!; track entry.id; let i = $index) {
          <div class="flex items-center gap-6 text-sm">
            <div class="flex w-[120px] min-w-0 items-center gap-2">
              <span class="h-2 w-2 shrink-0 rounded-full" [style.background-color]="legendDotColor(i)"></span>
              <span
                class="line-clamp-1 text-ellipsis"
                matTooltip
                matTooltipPosition="above"
                [appTextClampTooltip]="entry.name"
                >{{ entry.name }}</span
              >
            </div>
            <span [class.font-bold]="legendValueBold()">{{ entry.value | number }}</span>
          </div>
        }
      }
    </div>
  </div>
} @else {
  <ng-container [ngTemplateOutlet]="ring" />
}
